export default class mainNav {
  constructor(navSelector, navMenuSelector, navToggleSelector) {
    this.navEl = document.querySelector(navSelector);
    this.initObserver();

    this.navMenuEl = this.navEl.querySelector(navMenuSelector);
    this.navToggleEl = this.navEl.querySelector(navToggleSelector);
    this.initMenu();

    this.subMenuContaniners = this.navEl.querySelectorAll('.menu-item-has-children');
    this.subMenuEls = [];
    this.subMenuToggles = [];
    this.initSubs();
  }

  initObserver() {
    this.scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.navEl.classList.remove('is-moving');
        }
        else {
          this.navEl.classList.add('is-moving');
        }
      });
    }, {
      threshold: 1,
      // rootMargin: "100px 0px 0px 0px",
    });
  
    this.scrollObserver.observe(this.navEl.parentElement);
  }
  initMenu() {
    if (!this.navMenuEl || !this.navToggleEl) {
      return;
    }

    this.navToggleEl.addEventListener('click', event => {
      this.navMenuEl.classList.toggle('is-open');
    });

    document.addEventListener('click', event => {
      if (! this.navEl.contains(event.target)) {
        this.navMenuEl.classList.remove('is-open');

        this.subMenuEls.forEach(subMenuEl => {
          subMenuEl.classList.remove('is-open');
        });
      }
    });
  }
  initSubs() {
    this.subMenuContaniners.forEach(subMenuContainer => {
      let subMenuEl = subMenuContainer.querySelector('.sub-menu');
      let subMenuToggle = subMenuContainer.querySelector('.sub-menu-arrow');
      this.subMenuEls.push(subMenuEl);
      this.subMenuToggles.push(subMenuToggle);
    });

    this.navEl.addEventListener('click', event => {
      this.subMenuContaniners.forEach((subMenuContaniner, index) => {
        if (subMenuContaniner.contains(event.target)) {
          if (event.target === this.subMenuToggles[index] || this.subMenuToggles[index].contains(event.target)) {
            this.subMenuToggles[index].setAttribute('aria-expanded', ! this.subMenuEls[index].classList.contains('is-open'))
            this.subMenuEls[index].classList.toggle('is-open');
          }
        }
        else {
          this.subMenuEls[index].classList.remove('is-open');
          this.subMenuToggles[index].setAttribute('aria-expanded', false);
        }
      });
    });
  }
}